import { ModelDefinition, PlatformNext } from "@pureweb/platform-sdk";
import { ClientOptions } from "../types";
import logger from "../Log";

export class ModelService {
  static async initializeModels(
    platform: PlatformNext,
    clientOptions: ClientOptions
  ): Promise<ModelDefinition[]> {
    if (!clientOptions.ProjectId) {
      throw new Error("Project ID is required");
    }

    logger.info("Initializing available models: " + clientOptions.ProjectId);

    await platform.useAnonymousCredentials(
      clientOptions.ProjectId,
      clientOptions.EnvironmentId
    );
    await platform.connect();

    logger.info("Agent Connected: " + platform.agent.id);

    const models = await platform.getModels();
    logger.debug("Available models", models);

    return models;
  }

  static findSelectedModel(
    availableModels: ModelDefinition[],
    clientOptions: ClientOptions
  ): ModelDefinition | null {
    const selectedModels = availableModels.filter((model: ModelDefinition) => {
      if (clientOptions.ModelId === model.id) {
        if (clientOptions.Version && clientOptions.Version === model.version) {
          return true;
        }
        if (!clientOptions.Version && model.active) {
          return true;
        }
      }
      return false;
    });

    return selectedModels.length > 0 ? selectedModels[0] : null;
  }
}
